import styled from "styled-components"

export const CssButton = styled.button<{ active: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	pointer-events: all;

	background: ${(props) => (props.active ? "rgba(0, 0, 0, 0.1)" : "none")};
	border-radius: 10px;
	border: 0;
	outline: 0;
	cursor: pointer;

	width: 36px;
	height: 36px;

	transition: all 100ms ease-in-out;

	:hover {
		background-color: rgba(0, 0, 0, 0.05);
	}

	:active {
		background-color: rgba(0, 0, 0, 0.1);
	}

	:disabled {
		pointer-events: none;
		color: rgb(180, 180, 180);
	}
`

export const ButtonImage = styled.img.attrs({ draggable: false })`
	cursor: pointer;
`
